// frontend/src/components/Footer.js

import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get current year dynamically
  return (
    <footer style={styles.footer}>
      <p style={styles.text}>&copy; {currentYear} Logic Hub Solutions. All rights reserved.</p>
    </footer>
  );
};

// Basic inline styles for the footer
const styles = {
  footer: {
    backgroundColor: '#34495e', /* Match header/navbar background */
    color: 'white',
    textAlign: 'center',
    padding: '0.3rem 0',
    fontSize: '0.85rem',
    position: 'sticky', /* Makes it stick to the bottom of the viewport if content is short */
    bottom: '0',
    left: '0',
    width: '100%',
    boxSizing: 'border-box',
    flexShrink: 0, /* Prevents footer from shrinking */
  },
  text: {
    margin: 0,
    opacity: 0.8,
  }
};

export default Footer;